// languages/index.js
import { de } from './de';
import { en } from './en';

export const languages = {
  de,
  en
};

export const availableLanguages = [
  { code: 'de', name: 'DE' },
  { code: 'en', name: 'EN' }
];

export const defaultLanguage = 'de';